// src/utils/validation.js

export const REGEX_ALPHABETICAL = /^[A-Za-z\s]+$/;
export const REGEX_NUMERICAL = /^\d+$/;
export const REGEX_EMAIL = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
export const REGEX_COUNTRY_CODE = /^\+\d{1,3}$/;
export const REGEX_DUTCH_ZIPCODE = /^\d{4}\s?[A-Z]{2}$/i;
export const REGEX_PHONE = /^\+?\d{9,15}$/;
export const REGEX_ALPHABETICAL_SPACE = /^[A-Za-z\s]+$/;
export const REGEX_DUTCH_HOUSENUMBER = /^\d+([A-Za-z]{1,2})?$/i;
export const REGEX_ALPHANUMERICAL_SPACE = /^[A-Za-z0-9\s.,?!/:;()&'"-]+$/;

export const ALLOWED_IMAGE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
];
